<template>
    <span></span>
</template>

<script>

export default {
    name: "CountdownCloseClass",
    props: [
        'tutoring'
    ],
    data() {
        const time_current = Math.floor(Date.now() / 1000);

        const time_countdown_1 = this.tutoring.time_end - time_current;

        return {
            time_countdown_1: time_countdown_1,
        };
    },

    computed: {
        live_class_data() {
            return this.$store.state.live_classes;
        },
    },

    watch: {
        time_countdown_1: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.time_countdown_1--;
                    }, 1000);
                }else{
                    this.tutoring.status = 4;
                }
            },
            immediate: true
        },
    },

    created() {},

    methods: {

    }
}
</script>

<style scoped>

</style>
